import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MenuOpenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"menu_open"}/>
}
